(function () {
    angular.module('tmx-app').controller('userLimitManagementCtrl', ['$state','$filter','$mdMedia','$mdDialog','$mdSidenav', 'tmxUtility','menu','UserLimitManagementService','TmxDialogService','ToastService',

        function UserLimitManagementCtrl($state,$filter,$mdMedia, $mdDialog, $mdSidenav, tmxUtility,menu,UserLimitManagementService,TmxDialogService,ToastService) {
            //#region  =========== Variable Initialization ================
            var userLimitVM = this;
            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            userLimitVM.checkPermission = tmxUtility.checkPermission;
            userLimitVM.onChildState = onChildState;
            userLimitVM.isOpen = isOpen;
            userLimitVM.toggleSearch = toggleSearch;
            userLimitVM.toggleExport = toggleExport;
            userLimitVM.toggle = toggle;
            userLimitVM.menu=menu;
            userLimitVM.isFiltered = isFiltered;
            userLimitVM.searchSideNavActive=false;
            userLimitVM.exportSideNavActive=false;
            userLimitVM.search=search;
            userLimitVM.clear=clear;
            userLimitVM.cols = UserLimitManagementService.GetGridColumns();


            userLimitVM.viewPermission = userLimitVM.checkPermission("Private.Administration.UserLimitManagement","Info") ;
            userLimitVM.editPermission = userLimitVM.checkPermission("Private.Administration.UserLimitManagement","Edit") ;
            userLimitVM.addPermission = userLimitVM.checkPermission("Private.Administration.UserLimitManagement","Create") ;
            userLimitVM.deletePermission = userLimitVM.checkPermission("Private.Administration.UserLimitManagement","Delete") ;
            
            //#endregion

             //#region ============= Local Functions ============================

            function onChildState() {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0)
                    return true;
                else
                    return false;
            }
            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }

            function toggleSearch() {
                if (userLimitVM.searchSideNavActive) {
                    userLimitVM.searchData = {};
                    userLimitVM.searchSideNavActive = false;
                }
                else
                    userLimitVM.searchSideNavActive = true;
                userLimitVM.toggle('SearchSideNav');
            }


            function toggleExport() {
                if (userLimitVM.exportSideNavActive)
                    userLimitVM.exportSideNavActive = false;
                else
                    userLimitVM.exportSideNavActive = true;
                userLimitVM.toggle('ExportSideNav');
            }

            function toggle(navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () {
                    });
            }

            function isFiltered(fieldName){
                var filtered = false;
        
                if(angular.isDefined(userLimitVM.filters)){
                    userLimitVM.filters.filters.forEach(function(filter){
                        if(filter.field==fieldName)
                            filtered = true;
                    });
                }
                return filtered;
            }

            function search (navID) {
                var calls=[];
                for (var key in userLimitVM.searchData) {
                    if (userLimitVM.searchData.hasOwnProperty(key)) {
                        calls.push({
                            field: key,
                            operator: "contains",
                            value: userLimitVM.searchData[key]
                        });
                    }
                }
         
                userLimitVM.filt = {
                    filters: calls,
                    logic: "and"
                };
               
                userLimitVM.o.data.filter = userLimitVM.filt;
                userLimitVM.container.LookupGrid.dataSource.transport.read(userLimitVM.o);
         
                userLimitVM.searchData = {};
                userLimitVM.toggle(navID);
            }
         
            function clear (navID) {
                userLimitVM.searchData = {};
                userLimitVM.toggle(navID);
            }

            var previousGrouping = {};

            function onDataBinding(e) {
                var dataSource = this.dataSource;
                var groups = dataSource.group();

                if (groups.length > 1) {
                    e.preventDefault();
                    for (var i = 0; i < groups.length; i++) {
                        if (previousGrouping.length > 0 && (groups[i].field == previousGrouping[0].field)) {
                            groups.splice(i, 1);
                        }
                    }
                    setTimeout(function() {
                        dataSource.read();
                    });
                }

                previousGrouping = groups;
            }

            //#endregion

            //#region ========= Scope Functions ==========================

            userLimitVM.clickEdit = function(item){
                if(userLimitVM.editPermission) {
                    $state.data.LoanLimitId = item.LoanLimitId;                   
                    $state.go($state.current.name + ".edit", {"Id": item.LoanLimitId});
                }
            }
            userLimitVM.clickAdd = function() {
                $state.data.info = false;
                $state.go($state.current.name + ".add");
            };
            userLimitVM.formatAmount = function(amount){
                return tmxUtility.formatAmount(amount);
            }
            userLimitVM.clickDelete = function(dataItem){
                let messageText = 'Are you sure you want to remove this item?';
                let messageTitle = `Confirm`
                TmxDialogService.showConfirmDialog(messageTitle,messageText,deleteLimitRecord);
                function deleteLimitRecord() {
                    UserLimitManagementService.DeleteLimitById(dataItem.LoanLimitId).then(function() {
                        $('#grid').data('kendoGrid').dataSource.read();
                    })
                }
            }
            userLimitVM.changeLimit = function(item){
                $mdDialog.show({
                    controller: ['$mdDialog','$scope','tmxUtility','data',  changeLimitController],
                    locals: {
                        data: item
                    },
                    templateUrl: 'app/private/administration/user-limit-management/change-limit-dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: true
                }).then(function (returnData) { // After closing the dialog
                    if(!tmxUtility.exists(returnData)){
                        return;
                    }
                    let data = returnData;
                    UserLimitManagementService.changeLoanLimits(data).then(function(result){
                        if(result.status.code == "200"){
                            ToastService.showCustomToast("success", $filter('translate')("LimitUpdateSuccess"));
                            $('#grid').data('kendoGrid').dataSource.read();
                            return;
                        }
                        ToastService.showCustomToast("error", $filter('translate')("LimitUpdateFail"));
                    });

                }, function () {
    
                });
            }

            //#endregion

            //#region =========== Grid Initializtion======================

            function InitializeGrid(){
                userLimitVM.mainGridOptions = {
                    dataSource: {
            
                        transport: {
                            read: function(o){
                                if(angular.isDefined(userLimitVM.searchClear) && userLimitVM.searchClear==false){
                                    if(exists(userLimitVM.o)){
                                        copy(userLimitVM.o.data,["filter"],o.data);
                                    }
                                }
                                userLimitVM.searchClear = false;
                                if(userLimitVM.onChildState()){
                                    return;
                                }
                                if(!o.fromSideNav) {
                                    if($state.searchClear){
                                        userLimitVM.searchClear = true;
                                        $state.searchClear=undefined;
                                      
                                    }
                                  
                                }
                                else{
                                    o.data.firstPage = true;
                                }
                                userLimitVM.o = angular.copy(o);
                                userLimitVM.filters = userLimitVM.o.data.filter;
                                UserLimitManagementService.getByParams(o,true,'/GetLoanLimitsList').then(function(response){
                                   
                                                                        
                                    if(response.data.length==0) {
                                        userLimitVM.no_records = true;
                                    }
                                    else {
                                        userLimitVM.no_records = false;
                                    }
                                    o.success(response);
                                });
                            },
            
                            dataType: "json"
                        },
                        schema: {
                            data: "data",
                            total: "Total"
                        },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        sort:  [{field: "UserName", dir: "asc"}]
            
                        // sort:  [{field: "EffectiveEndDate", dir: "desc"}],
                    },
                    // selectable: "multiple, row",
                    pageable: {
                        refresh: true,
                        pageSizes: [10,20,50,100,'All'],
                        pageSize: 20,
                        buttonCount: 5
                    },
                    pdf: {
                        allPages: true,
                        fileName: "User Limits.pdf"
                    },
                    excel: {
                        allPages: true,
                        fileName: "User Limits.xlsx"
                    },
                    excelExport: function(e) {
                        var columns = e.workbook.sheets[0].columns;
                        columns.forEach(function(column){
                            delete column.width;
                            column.autoWidth = true;
                        });
                    },
                    // filterable:true,
                    // sortable: true,
                    sortable:true,
                    scrollable: !$mdMedia('gt-sm'),
                    dataBinding: onDataBinding,
                    groupable: true,
                    columns: UserLimitManagementService.GetGridColumns()
                };
            
                $state.data={
                    // groupable: true,
                    grid: userLimitVM.container,
                    info: false
            
                };
                
            }
            //#endregion

            //#endregion

            //#region  ========== Child Controllers ========================
            function changeLimitController($mdDialog,$scope,tmxUtility,data) {

                $scope.data = data;
                $scope.showLoanEditableFields = false;

                $scope.done = function(){

                    $scope.limitDialogCtrl.dialogForm.$submitted = true;
                    if(!$scope.limitDialogCtrl.dialogForm.$valid){
                        return;
                    }
                    $mdDialog.hide($scope.data);
                }

                $scope.cancel = function(){
                    $mdDialog.hide();
                }

                function InitializeData(){
                }

                (function InitializePage(){
                    InitializeData();
                })();
            }
            //#endregion
            (function InitializePage(){
                InitializeGrid();
            })();
        }]);
})();